import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import { history } from '../../config/historia'
import { loginApi, getMeInfoApi, logoutApi } from '../../services/user.service';
import actions from './actions'
import { tekst } from "../../utils/tlumacz";
import {ROUTE_LOGIN, ROUTE_TELEMETRY, ROUTE_WORKSPACE_BLOCKED, ROUTE_WORKSPACES_LIST} from "../../config/routes";
import axios, { AxiosResponse } from 'axios';
import { WorkspaceType } from "./user.type";
import {getSessionSuperAdminWorkspace} from "../../utils/utils";
import userActions from "../user/actions";
import storedDataActions from "../storedData/actions"
import logError from "../../utils/logError";

function* initialValue(){
  yield put({
    type: storedDataActions.SET_INITIAL_PAGINATION_PAGE_WORKSPACE_LIST,
  })
}

export function* LOGIN(action: {payload: any, type: string}) {
  const { payload } = action;
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  });
  try {
    const success: AxiosResponse<any> = yield call(loginApi, payload.values);
    if (success.data) {

      yield localStorage.setItem('access_token', success.data.access_token);
      yield sessionStorage.setItem('access_token', success.data.access_token);
      yield axios.defaults.headers.common['Authorization'] = `Bearer ${success.data.access_token}`;
      yield put({
        type: userActions.LOAD_CURRENT_ACCOUNT
      });
      yield put({
        type: actions.SET_STATE,
        payload: {
          authorized: true
        },
      });
      try {
        const response: AxiosResponse<any> = yield call(getMeInfoApi);
        if(response.data){
          const { workspaces } = response.data;
          const {is_super_admin} = response.data;
          if(workspaces && workspaces[0] && workspaces[0].customer_type && workspaces[0].customer_type === "S") {
            sessionStorage.setItem("subscriber", 'true');
            localStorage.setItem("subscriber", 'true');
          } else {
            sessionStorage.setItem("subscriber", 'false');
            localStorage.setItem("subscriber", 'false');
          }

          if (is_super_admin){
            sessionStorage.setItem("superAdmin", 'true');
            localStorage.setItem("superAdmin", 'true');

            // sessionStorage.setItem("subscriber", 'true');
            // localStorage.setItem("subscriber", 'true');

            sessionStorage.removeItem("superAdminWorkspace");
            localStorage.removeItem("superAdminWorkspace");
            yield history.push(ROUTE_WORKSPACES_LIST)
          } else if (workspaces[workspaces.length-1].is_blocked) {
            sessionStorage.removeItem("superAdmin");
            localStorage.removeItem("superAdmin");
            sessionStorage.removeItem("superAdminWorkspace");
            localStorage.removeItem("superAdminWorkspace");
            yield history.push(ROUTE_WORKSPACE_BLOCKED)
          } else {
            sessionStorage.removeItem("superAdmin");
            localStorage.removeItem("superAdmin");
            sessionStorage.removeItem("superAdminWorkspace");
            localStorage.removeItem("superAdminWorkspace");
            yield history.push(ROUTE_TELEMETRY)
          }
          yield notification.success({
            message: tekst('logged_in_notification'),
            description: tekst('logged_in_notification_desc'),
          });
          // if (pathName && !pathName.includes("login")){
          //   yield history.push(pathName);
          // } else {
          //   if (sessionStorage.getItem("superAdmin")) yield history.push(ROUTE_WORKSPACES_LIST);
          //   else yield history.push(ROUTE_TELEMETRY)
          // }
        }
      } catch (e) { logError("redux/user/sagas/LOGIN", e); }
  }
  } catch (e) {
    yield call(initialValue);
    yield put({
      type: actions.SET_STATE,
      payload: {
        loading: false,
        authorized: false
      },
    });
    notification.error({
      message: tekst('logged_error_notification'),
      description: tekst('logged_error_notification_desc'),
    })
  }
}

export function* LOAD_CURRENT_ACCOUNT() {
  try {
    console.log("load_current_account");
    const response: AxiosResponse<any> = yield call(getMeInfoApi);
    if (response.data) {
      sessionStorage.setItem("superAdmin", response.data.is_super_admin);
      localStorage.setItem("superAdmin", response.data.is_super_admin);

      let { data } = response;
      let activeWorkspace = null;
      if (sessionStorage.getItem("superAdminWorkspace")){
        // sessionStorage.setItem("subscriber", 'true');
        // localStorage.setItem("subscriber", 'true');
        if(data.workspaces && data.workspaces.length > 0 && data.workspaces[0].customer_type && data.workspaces[0].customer_type === "S") {
          sessionStorage.setItem("subscriber", 'true');
          localStorage.setItem("subscriber", 'true');
        } else {
          sessionStorage.setItem("subscriber", 'false');
          localStorage.setItem("subscriber", 'false');
        }
        data.activeWorkspace = getSessionSuperAdminWorkspace()
      } else if (data.workspaces && data.workspaces.length > 0) {
        if(data.workspaces[0].customer_type && data.workspaces[0].customer_type === "S") {
          sessionStorage.setItem("subscriber", 'true');
          localStorage.setItem("subscriber", 'true');
        } else {
          sessionStorage.setItem("subscriber", 'false');
          localStorage.setItem("subscriber", 'false');
        }

        activeWorkspace = sessionStorage.getItem('active_workspace') ?
            data.workspaces.find((el: WorkspaceType) => el.uuid === sessionStorage.getItem('active_workspace')) : null;
        if (activeWorkspace === null || activeWorkspace === undefined) {
          activeWorkspace = data.workspaces[0];
        }
        yield sessionStorage.setItem('active_workspace', activeWorkspace.uuid);
        yield localStorage.setItem('active_workspace', activeWorkspace.uuid);
      }

      if(data.activeWorkspace) {
        if(data.activeWorkspace.customer_type && data.activeWorkspace.customer_type === "S") {
          sessionStorage.setItem("subscriber", 'true');
          localStorage.setItem("subscriber", 'true');
        } else {
          sessionStorage.setItem("subscriber", 'false');
          localStorage.setItem("subscriber", 'false');
        }
      }

      yield put({
        type: actions.SET_STATE,
        payload: {
          ...data,
          authorized: true,
          activeWorkspace: getSessionSuperAdminWorkspace() || activeWorkspace
        },
      })
    }
  } catch (e) { logError("redux/user/sagas/LOAD_CURRENT_ACCOUNT", e); }
}

export function* LOGOUT(action: {payload: string, type: string}) {
  try {
    yield call(logoutApi);
  } catch (e) { logError("redux/user/sagas/LOGOUT", e); }
  yield put({
    type: actions.LOCAL_LOGOUT,
    payload: action.payload
  });
}

export function* LOCAL_LOGOUT(action: {payload: string, type: string}) {
  yield sessionStorage.removeItem('access_token');
  console.log("local_logout");
  yield history.push({ pathname: ROUTE_LOGIN }, {pathName: action.payload});
  yield put({
    type: actions.SET_STATE,
    payload: {
      email: '',
      uuid: '',
      first_name: '',
      last_name: '',
      workspaces: [],
      loading: false,
      authorized: false,
      activeWorkspace: null
    },
  })
}

export function* CHANGE_ACTIVE_WORKSPACE(action: {payload: WorkspaceType, type: string}) {
  const { payload } = action;
  sessionStorage.setItem('active_workspace', payload.uuid);
  yield put({
    type: actions.SET_STATE,
    payload: {
      activeWorkspace: payload,
    },
  });
  yield call(LOAD_CURRENT_ACCOUNT)
  // notification.success({
  //   message: tekst('workspace_change_user_menu_success'),
  //   description: tekst('workspace_change_user_menu_success_info'),
  // });
  // setTimeout(() => {
  //   window.location.reload();
  // }, 1500);
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOGIN, LOGIN),
    takeEvery(actions.LOAD_CURRENT_ACCOUNT, LOAD_CURRENT_ACCOUNT),
    takeEvery(actions.LOGOUT, LOGOUT),
    takeEvery(actions.LOCAL_LOGOUT, LOCAL_LOGOUT),
    takeEvery(actions.CHANGE_ACTIVE_WORKSPACE, CHANGE_ACTIVE_WORKSPACE),
    //LOAD_CURRENT_ACCOUNT(),
  ])
}
